module.exports = __webpack_public_path__ + "img/138_G_1529369156194.a8561960.jpg";